
import React, { Component, useEffect } from 'react';
import { connect } from 'react-redux';
import './App.css';
import {
  languageMenuAction,
  authMenuAction,
  toggle3DotMenuAction,
  profileMenuAction,
  dropDownMenuAction
} from './actions/settingsAction';
import AppRouting from './AppRouting';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      closeRightbarClass: "close_rightbar"
    };
  }

  componentDidMount() {
    // Your existing logic
    const ww = document.body.clientWidth;
    if (ww < 1530) {
      this.setState({ closeRightbarClass: "close_rightbar" });
    } else {
      this.setState({ closeRightbarClass: "" });
    }
    document.addEventListener("mousedown", this.hideLeftSidebarProxy, false);

    // Add ResizeObserver error listener here
    window.addEventListener("error", this.handleResizeObserverError);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.hideLeftSidebarProxy, false);

    // Remove ResizeObserver error listener here
    window.removeEventListener("error", this.handleResizeObserverError);
  }

  handleResizeObserverError = (event) => {
    if (
      event.message &&
      event.message.includes("ResizeObserver loop completed with undelivered notifications")
    ) {
      event.stopImmediatePropagation();
    }
  };

  hideLeftSidebarProxy = (e) => {
    const {
      authMenuAction,
      languageMenuAction,
      dropDownMenuAction,
      toggle3DotMenuAction
    } = this.props;

    if (this.leftSidebar && this.leftSidebar.contains(e.target)) {
      authMenuAction(false);
      languageMenuAction(false);
      dropDownMenuAction(false);
      toggle3DotMenuAction(false);
    }
  };

  render() {
    const { closeRightbarClass } = this.state;
    const {
      toggleRightBar,
      toggleLeftBar,
      themeColor,
    } = this.props;

    return (
      <div
        ref={(ref) => (this.leftSidebar = ref)}
        className={`
          ${toggleLeftBar ? "offcanvas-active" : ""}
          ${toggleRightBar ? "right_tb_toggle" : "right_tb_toggle"}
          ${closeRightbarClass}
          theme-${themeColor}
        `}
      >
        <AppRouting />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  toggleRightBar: state.settings.isToggleRightBar,
  toggleLeftBar: state.settings.isToggleLeftBar,
  themeColor: state.settings.themeColor,
});

const mapDispatchToProps = (dispatch) => ({
  toggle3DotMenuAction: (e) => dispatch(toggle3DotMenuAction(e)),
  authMenuAction: (e) => dispatch(authMenuAction(e)),
  languageMenuAction: (e) => dispatch(languageMenuAction(e)),
  profileMenuAction: (e) => dispatch(profileMenuAction(e)),
  dropDownMenuAction: (e) => dispatch(dropDownMenuAction(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);